import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'

import {
  QuoteOuter,
  QuoteWrapper,
  NameWrapper,
  AvatarWrapper,
  TextWrapper,
} from './HerolessQuote.styles'

const HerolessQuote = ({
  quote,
  nameHead,
  nameSub,
  avatar,
  pad,
  mobilePad,
}) => {
  return (
    <QuoteOuter pad={pad} mobilePad={mobilePad}>
      <QuoteWrapper>
        <p>“{quote}”</p>
      </QuoteWrapper>
      {avatar && (
        <NameWrapper>
          <AvatarWrapper>
            <GatsbyImage image={avatar} alt="Avatar image" />
          </AvatarWrapper>
          <TextWrapper>
            <p className="head">{nameHead}</p>
            <p className="sub">{nameSub}</p>
          </TextWrapper>
        </NameWrapper>
      )}
    </QuoteOuter>
  )
}

HerolessQuote.defaultProps = {
  quote: `"Over the last 4 months, my mentor helped me identify my career path and really taught me how to network. It changed my perspective on how to get my next job." `,
  nameHead: `Melissa Hoffbauer, PhD`,
  nameSub: `Senior Consultant at Guidehouse`,
  pad: `12rem 1.8rem`,
  mobilePad: `6rem 1.8rem`,
  avatar: null,
}

HerolessQuote.propTypes = {
  pad: PropTypes.string,
  mobilePad: PropTypes.string,
  quote: PropTypes.string,
  nameHead: PropTypes.string,
  nameSub: PropTypes.string,
  avatar: PropTypes.object,
}

export default HerolessQuote
